import { DataMap } from '../../../classes';
import { ResponseTime } from '../../../types';
import { formatDateTime } from '../../../utils/format-time';

export const buildChartData = (
  currentDataMap: DataMap,
  rangeSetting: number,
  chartType: string
): any => {
    let dataset: ResponseTime[]= [];
    switch(rangeSetting) {
      case 84600:
        dataset = currentDataMap.getChartData(chartType);
        if(dataset.length === 0) {
        }
        return {
          data: dataset,
          range: setRange(dataset)
        }
      default:
        dataset = currentDataMap.getSubsetChartData(rangeSetting, chartType);
        return {
        data: dataset,
        range: setRange(dataset)
      }
    }
  }

const setRange = (data: ResponseTime[]) => {
  if(data[0] !== undefined) {
    const startId: number = data[0].id;
    const endId: number = data[data.length -1].id
    const start: string = formatDateTime(startId, true);
    const end: string = formatDateTime(endId, true);
    return `(${start} - ${end})`;
  } else {
      return 'response time data not found'
  }
}






// WEBPACK FOOTER //
// ./src/components/ChartCard/utils/buildChartData.ts